import type {z} from 'zod';

import {keys} from 'ramda';

import {optionalNonNegativeIntInput} from './catalogueUi';

type PresentedTechnicalData<S extends z.ZodRawShape, K extends keyof S> = {
  [P in K]?: S[P] extends typeof optionalNonNegativeIntInput ? number : string;
};

/** Drops empty inputs and sends the fields the schema validates as whole numbers as numbers. */
export const presentTechnicalData = <S extends z.ZodRawShape, K extends keyof S & string>(
  shape: S,
  values: Record<K, string>
): PresentedTechnicalData<S, K> =>
  keys(values).reduce<PresentedTechnicalData<S, K>>((presented, key) => {
    const field: z.ZodRawShape[string] = shape[key];
    const value = values[key];
    if (value === '') {
      return presented;
    }
    return {...presented, [key]: field === optionalNonNegativeIntInput ? Number(value) : value};
  }, {});
